export default __webpack_public_path__ + "static/media/rolesUXEngineering.4712497f.svg";